// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"4c355c98","99":"780ec1ef","123":"03c65498","125":"09d3036b","254":"8bb9a254","300":"5e18c90f","354":"ae9eedb1","579":"6e9c6c52","588":"ba6ecd36","652":"14dc4b36","783":"8e2fd68f","786":"4f490d18","790":"219fa904","858":"58e2980e","901":"c9fbe78d"}[chunkId] + ".chunk.js";
};